<template>
  <span
    v-if="isAutomatischAngefragt"
    class="d-inline-flex align-items-center"
    v-b-tooltip.hover
    title="Ticket automatisch angefragt"
  >
    <Bot :size="20" />
  </span>
  <span v-else>-</span>
</template>

<script>
import { Bot } from 'lucide-vue';

export default {
  components: { Bot },
  computed: {
    isAutomatischAngefragt() {
      return this.params?.data?.ticketAngefragtStatus === 'TicketAutomatischAngefragt';
    },
  },
};
</script>
